import axios from "axios";
import { authHeader, multipartHeader } from "./auth-header";

const getAll = (keyword, page, perPage, all, active) => {
  return axios.get(process.env.REACT_APP_API_URL + "storageItem/list", {
    headers: authHeader(),
    data: {},
    params: {
      keyword,
      page,
      perPage,
      all,
      active,
    },
  });
};
const getAllByCategory = (storageType) => {
  return axios.get(process.env.REACT_APP_API_URL + "storageItems/listbycategory", {
    headers: authHeader(),
    data: {},
    params: {
      storageType,
    },
  });
};

const get = (id) => {
  return axios.get(
    process.env.REACT_APP_API_URL + `storageItem/view/${id}`,
    {
      headers: authHeader(),
    }
  );
};

const create = (data) => {
  return axios.post(
    process.env.REACT_APP_API_URL + `storageItem/create`, data, {
      headers: multipartHeader(),
    }
  );
};

const update = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `storageItem/update/${id}`,
    data,
    {
      headers: multipartHeader(),
    }
  );
};

const updateStatus = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `storageItem/updateStatus/${id}`,
    data,
    {
      headers: authHeader(),
    }
  );
};

const deleteStorageItem = (id, data) => {
  return axios.delete(
    process.env.REACT_APP_API_URL + `storageItem/delete/${id}`,
    {
      headers: authHeader(),
      data,
    }
  );
};

const restore = (id, data) => {
  return axios.get(
    process.env.REACT_APP_API_URL + `storageItem/restore/${id}`,
    {
      headers: authHeader(),
      params: data,
    }
  );
};

const getStorageItems = () => {
  return axios.get(process.env.REACT_APP_API_URL + "storageItems/list", {
    headers: authHeader(),
  });
};

export default {
  getAll,
  get,
  create,
  update,
  updateStatus,
  deleteStorageItem,
  restore,
  getAllByCategory,
  getStorageItems
};
